export enum InputStateVisibility {
  UNLOCKED = 'unlocked',
  LOCKED_CTA = 'locked_cta',
  LOCKED_OTHER_AGENT_ASSIGNED = 'locked_other_agent_assigned',
  LOCKED_ATTENDANCE_STOPPED = 'locked_attendance_stoped',
  LOCKED_NOT_ALLOWED_INTERVENTION = 'locked_not_allowed_intervention',
  LOCKED_ATTENDANCE_ARCHIVED = 'locked_attendance_archived',
  LOCKED_NOT_SUPPORTED_CHANNEL = 'locked_not_supported_channel',
  LOCKED_EMAIL_ATTENDANCE = 'locked_email_attendance',
  LOCKED_BOOKING_ATTENDANCE = 'locked_booking_attendance',
  LOCKED_EXPEDIA_ATTENDANCE = 'locked_expedia_attendance',
  LOCKED_TIKTOK_ATTENDANCE = 'locked_tiktok_attendance',
  LOCKED_INSTAGRAM_INTEGRITY = 'locked_instagram_integrity',
  LOCKED_CONTACT_BLOCKED = 'locked_contact_blocked',
  LOCKED_CREDITS_EXHAUSTED = 'locked_credits_exhausted',

  LOADING_CTA = 'loading_cta',
  HAS_OTHER_CONTACT_CHANNEL = 'has_other_contact_channel',
  HAS_NO_OTHER_CONTACT_CHANNEL = 'has_not_other_contact_channel',
  HAS_NEXT_ATTENDANCE = 'has_next_attendance',

  IS_CHANNEL_PHONE = 'is_channel_phone',
  
  COMPANY_LOADING = 'company_loading',
}
